import React from "react";
import Table from "./ui/Table";

const TableComponent = ({tableHeaders, tableColumns, tableData, onViewReason,loading}) => {
 

  return (
    <Table headers={tableHeaders} columns={tableColumns} data={tableData} onViewReason={onViewReason} loading={loading}  />
  );
};

export default TableComponent;
